import { render, staticRenderFns } from "./roomOweFees.vue?vue&type=template&id=b458c2a0&scoped=true"
import script from "./roomOweFees.vue?vue&type=script&lang=js"
export * from "./roomOweFees.vue?vue&type=script&lang=js"
import style0 from "./roomOweFees.vue?vue&type=style&index=0&id=b458c2a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b458c2a0",
  null
  
)

export default component.exports